module.exports = __webpack_public_path__ + "static/media/grants-pass@2x.76382272.webp";